export const weddingFormPersonQuestions = (inputs) => [
  {
    type: `form`,
    textOnlyInQuestions: true,
  },
  {
    text: 'RELACIONES ANTERIORES',
    type: 'title',
  },
  {
    text: '¿Eres separado o divorciado?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `divorced`,
  },
  ...(inputs?.[`divorced`] === 'Sí'
    ? [
        {
          text: 'Por favor conteste las siguientes preguntas.',
          type: 'text',
        },
        {
          text: 'Tiempo de matrimonio:',
          type: 'input',
          id: `prev_marriage_duration`,
        },
        {
          text: 'Fecha de separación:',
          type: 'date',
          id: `separation_date`,
        },
        {
          text: 'Fecha de divorcio:',
          type: 'date',
          id: `divorce_date`,
        },
        {
          text: 'Situación legal actual de la relación:',
          type: 'input',
          id: `current_legal_status`,
        },
        {
          text: '¿Intentaron la reconciliación?',
          type: 'select',
          options: ['Sí', 'No'],
          id: `attempted_reconciliation`,
        },
        {
          text: 'Motivo de separación:',
          type: 'input',
          id: `separation_reason`,
        },
        {
          text: '¿Tienen hijos?',
          type: 'select',
          options: ['Sí', 'No'],
          id: `has_children`,
        },
        ...(inputs?.[`has_children`] === 'Sí'
          ? [
              {
                text: '¿Cuántos?:',
                type: 'input',
                kind: 'number',
                id: `how_many_children`,
              },
            ]
          : []),
      ]
    : []),
  {
    text: 'VIDA ESPIRITUAL',
    type: 'title',
  },
  {
    text: '¿Asiste a una iglesia?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `attends_church`,
  },
  ...(inputs?.[`attends_church`] === 'Sí'
    ? [
        {
          text: '¿Cuál iglesia?',
          type: 'input',
          id: `church_name`,
        },

        {
          text: '¿Hace cuánto tiempo asiste?',
          type: 'input',
          id: `church_attendance_duration`,
        },
        {
          text: '¿Tiene líder en esa iglesia?',
          type: 'select',
          options: ['Sí', 'No'],
          id: `has_leader`,
        },
        ...(inputs?.[`has_leader`] === 'Sí'
          ? [
              {
                text: 'Nombre del líder:',
                type: 'input',
                id: `leader_name`,
              },
              {
                text: 'Número de contacto del líder:',
                type: 'input',
                kind: 'number',
                id: `leader_contact`,
              },
            ]
          : []),
        {
          text: '¿Ha asistido a un encuentro en esta iglesia?',
          type: 'select',
          options: ['Sí', 'No'],
          id: `attended_encounter`,
        },
        ...(inputs?.[`attended_encounter`] === 'Sí'
          ? [
              {
                text: '¿Cuándo asistió al encuentro?',
                type: 'date',
                id: `encounter_date`,
              },
            ]
          : []),
      ]
    : []),
];

export const emptyWeddingFormPersonAnswers = {
  divorced: null,
  prev_marriage_duration: null,
  separation_date: null,
  divorce_date: null,
  current_legal_status: null,
  attempted_reconciliation: null,
  separation_reason: null,
  has_children: null,
  how_many_children: null,
  attends_church: null,
  church_name: null,
  church_attendance_duration: null,
  has_leader: null,
  leader_name: null,
  leader_contact: null,
  attended_encounter: null,
  encounter_date: null,
};
